define('SageDotCom/DataLayer/Global/scrolling',['jquery',
        'underscore',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Util/scrollHelper',
        'SageDotCom/DataLayer/Events/scroll'],
    function ($, _, tealium, scrollHelper, scrollEvent) {
        function globalScrollTracking() { }

        globalScrollTracking.prototype.initialize = function initialize() {
            var scrollPoints = [10, 25, 50, 75, 90, 100]; // list of scroll points tealium is interested in
            var lastTracked = 0;

            // only fire every 500ms, otherwise this will trigger way too many times
            var scrollHandler = _.throttle(function () {
                // grab percent scrolled down the page
                var amt = scrollHelper.percentScrolled();

                // check the scrollPoints from greatest to least greatest to determine if you have scrolled 
                // past one of them. If you have, and if we didn't _just_ track that point, then trigger a track event for it
                for (var i = scrollPoints.length; i >= 0; i--) {
                    if (amt >= scrollPoints[i]) { // check each amount, in descending order
                        if (lastTracked !== scrollPoints[i]) { // make sure you didn't just send an event to tealium for this point
                            lastTracked = scrollPoints[i];

                            var event = scrollEvent.GenerateEventMetadata(lastTracked);

                            // Store event data on window.optimizely.events
                            if (typeof window.optimizely !== "object") {
                                window.optimizely = {};
                            }

                            if (!Array.isArray(window.optimizely.events)) {
                                window.optimizely.events = [];
                            }

                            window.optimizely.events.push({
                                name: event.event_name,
                                value: event.event_label
                            });

                            // Keep current event & send to Tealium
                            tealium.event(event);
                        }
                        break; // break the loop that tries to map the various scroll points
                    }
                }

                // remove anything less than what was scrolled to, so we don't fire duplicates as the user scrolls up and down
                scrollPoints = scrollPoints.filter(function(x) {
                    return x > lastTracked;
                });

            }, 500);

            $(window).scroll(scrollHandler);
        }

        return new globalScrollTracking();
    });
